const deepClone = (object: any) => {
  if (typeof window?.structuredClone !== "undefined") {
    return structuredClone(object);
  } else {
    return JSON.parse(JSON.stringify(object));
  }
};

export default deepClone;
